import type { FC, ReactNode } from 'react'

import { useState } from 'react'
import { MapPin, Navigation } from 'lucide-react'
import { contact } from '@/constants/site'

const LATITUDE = 48.72568
const LONGITUDE = 9.11714

const EMBED_URL = `https://www.openstreetmap.org/export/embed.html?bbox=${LONGITUDE - 0.008}%2C${LATITUDE - 0.0035}%2C${LONGITUDE + 0.008}%2C${LATITUDE + 0.0035}&layer=mapnik&marker=${LATITUDE}%2C${LONGITUDE}`

// The map only loads after a click, so no data reaches OpenStreetMap before the visitor agrees
export const LocationMap: FC = (): ReactNode => {
    const [loaded, setLoaded] = useState(false)

    return (
        <div className='relative aspect-[4/3] overflow-hidden rounded-[1.75rem] bg-paper-deep'>
            {loaded
                ? (
                    <iframe
                        title={`Karte: ${contact.street}, ${contact.zip} ${contact.city}`}
                        src={EMBED_URL}
                        loading='lazy'
                        className='absolute inset-0 h-full w-full border-0 [filter:grayscale(0.85)_contrast(1.05)_sepia(0.12)]'
                    />
                )
                : (
                    <div className='absolute inset-0 flex flex-col justify-between p-7 sm:p-8'>
                        <div aria-hidden='true' className='absolute inset-0 opacity-60 [background-image:linear-gradient(var(--border)_1px,transparent_1px),linear-gradient(90deg,var(--border)_1px,transparent_1px)] [background-size:44px_44px]' />
                        <div aria-hidden='true' className='absolute left-[58%] top-[46%] grid size-12 -translate-x-1/2 -translate-y-1/2 place-items-center rounded-full bg-brand text-ink shadow-[0_0_0_10px_rgba(247,143,30,0.18)]'>
                            <MapPin className='size-5' strokeWidth={1.75} />
                        </div>

                        <p className='relative font-mono text-[0.68rem] uppercase tracking-[0.18em] text-ink/60'>
                            Synergiepark · Stuttgart-Vaihingen
                        </p>

                        <div className='relative'>
                            <div className='flex flex-wrap items-center gap-3'>
                                <button
                                    type='button'
                                    onClick={() => setLoaded(true)}
                                    className='rounded-full bg-ink px-5 py-3 text-sm font-medium text-paper transition-colors duration-500 hover:bg-brand hover:text-ink'
                                >
                                    Karte laden
                                </button>
                                <a
                                    href={contact.mapsUrl}
                                    target='_blank'
                                    rel='noopener noreferrer'
                                    className='inline-flex items-center gap-2 rounded-full border border-ink/20 bg-paper/70 px-5 py-3 text-sm font-medium text-ink backdrop-blur transition-colors duration-500 hover:border-ink'
                                >
                                    <Navigation aria-hidden='true' className='size-4' strokeWidth={1.75} />
                                    Route planen
                                </a>
                            </div>
                            <p className='mt-3 text-xs leading-relaxed text-ink/60'>
                                Beim Laden der Karte werden Daten an OpenStreetMap übertragen.
                            </p>
                        </div>
                    </div>
                )}
        </div>
    )
}
